'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyles = exports.ButtonSizes = undefined;
exports.getButtonSize = getButtonSize;
exports.getButtonStyle = getButtonStyle;
exports.renderButton = renderButton;
exports.renderDisabledButton = renderDisabledButton;
exports.renderButtonWithTooltip = renderButtonWithTooltip;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
/* eslint-disable import/no-unresolved */


var ReactBootstrap = require('react-bootstrap');
/* eslint-enable import/no-unresolved */


var Button = ReactBootstrap.Button;
var Tooltip = ReactBootstrap.Tooltip;
var OverlayTrigger = ReactBootstrap.OverlayTrigger;
var ButtonSizes = exports.ButtonSizes = {
  SMALL: 'SMALL',
  DEFAULT: 'DEFAULT',
  LARGE: 'LARGE'
};
var ButtonStyles = exports.ButtonStyles = {
  DEFAULT: 'DEFAULT',
  PRIMARY: 'PRIMARY',
  DANGER: 'DANGER'
};

function getButtonSize(size) {
  if (size === ButtonSizes.SMALL) {
    return 'small';
  }

  if (size === ButtonSizes.LARGE) {
    return 'large';
  }

  return 'small';
}

function getButtonStyle(style) {
  if (style === ButtonStyles.PRIMARY) {
    return 'primary';
  }

  if (style === ButtonStyles.DANGER) {
    return 'danger';
  }

  return 'default';
}

function renderButton(params) {
  var renderInner = params.renderInner,
      size = params.size,
      style = params.style,
      clickEvent = params.clickEvent;
  return _react2['default'].createElement(Button, {
    bsStyle: style,
    bsSize: size,
    onClick: clickEvent
  }, renderInner());
}

function renderDisabledButton(params) {
  var renderInner = params.renderInner,
      size = params.size,
      style = params.style;
  return _react2['default'].createElement(Button, {
    bsStyle: style,
    bsSize: size,
    disabled: true
  }, renderInner());
}

function renderButtonWithTooltip(params, other) {
  var renderInner = params.renderInner,
      size = params.size,
      style = params.style,
      clickEvent = params.clickEvent;
  var tooltipText = other.tooltipText,
      placement = other.placement,
      animation = other.animation,
      delayShow = other.delayShow,
      delayHide = other.delayHide;

  var tooltip = _react2['default'].createElement(Tooltip, null, tooltipText);

  return _react2['default'].createElement(OverlayTrigger, {
    placement: placement,
    overlay: tooltip,
    animation: animation,
    delayShow: delayShow,
    delayHide: delayHide
  }, _react2['default'].createElement(Button, {
    bsStyle: style,
    bsSize: size,
    onClick: clickEvent
  }, renderInner()));
}